var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerpetualFuturesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 9.7",
    style: {
      enableBackground: "new 0 0 18 9.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3,2.3c-0.9-1.5-2.6-2.4-4.3-2.3c-1.3,0.1-2.5,0.7-3.3,1.8C9.7,1.9,9.8,2,9.8,2.1l0.9,1.7l0.1-0.3 C11.2,2.7,12.1,2.1,13,2c1.6-0.1,2.9,1.2,2.9,2.7s-1.2,2.9-2.7,2.9c-0.1,0-0.1,0-0.2,0c-1-0.1-1.8-0.7-2.2-1.5l-0.7-1.3L8.9,2.6 C8.2,1.1,6.7,0.1,5,0C2.4-0.1,0.1,2,0,4.6c-0.1,2.7,2,4.9,4.6,5c0.1,0,0.3,0,0.4,0C6.4,9.6,7.6,9,8.4,7.9C8.3,7.8,8.2,7.7,8.2,7.6 L7.3,5.9L7.2,6.2C6.7,7,5.9,7.6,5,7.7c-1,0-2-0.5-2.6-1.4c-0.6-0.9-0.6-2,0-2.9C2.9,2.5,3.8,2,4.8,2H5c1,0.1,1.8,0.7,2.2,1.5 l0.7,1.3l1.2,2.3c0.7,1.5,2.2,2.5,3.9,2.6h0.2c2.7,0,4.8-2.2,4.8-4.9C18,3.9,17.7,3.1,17.3,2.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerpetualFuturesIcon);
export default __webpack_public_path__ + "static/media/perpetual_futures_icon.c46865944e41f2f34f6fc76e3a67b3af.svg";
export { ForwardRef as ReactComponent };